// The ONE node placard — shared by the Compass and the Mountain. A small glass
// card with a gold hairline in a fixed home (below the mountain base, centred,
// above the ▼ circle): kicker = sector · STAGE, title = what lives at that
// node, one state line, and "Explore ▼" to go down to the ORB screen.
import React from 'react';
import { Pressable, StyleSheet, Text, View, useWindowDimensions } from 'react-native';
import { GlassFill } from './ui';
import { makeStyles } from './theme';

/** Gap kept free under the placard (the ▼ circle lives there). */
export const PLACARD_BOTTOM = 96;
export const PLACARD_H = 118;

export function NodePlacard({ kicker, text, state, onExplore }: { kicker: string; text: string; state: string; onExplore: () => void }) {
  const styles = useStyles();
  const { width } = useWindowDimensions();
  const w = Math.min(250, width - 24);
  return (
    <View style={[styles.card, { width: w, left: '50%', marginLeft: -w / 2, bottom: PLACARD_BOTTOM, minHeight: PLACARD_H - 20 }]}>
      <GlassFill radius={14} tone="strong" />
      <Text style={styles.kick} numberOfLines={1}>
        {kicker}
      </Text>
      <Text style={styles.title} numberOfLines={2}>
        {text}
      </Text>
      <Text style={styles.state} numberOfLines={1}>
        {state}
      </Text>
      <Pressable onPress={onExplore} hitSlop={8} style={styles.go}>
        <Text style={styles.goText}>Explore ▼</Text>
      </Pressable>
    </View>
  );
}

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    card: { position: 'absolute', zIndex: 35, borderRadius: 14, borderWidth: 1, borderColor: t.gold, padding: 12, gap: 4, overflow: 'hidden', boxShadow: `0 8px 24px ${t.glowSoft}` } as object,
    kick: { fontSize: 11, fontWeight: '800', letterSpacing: 1.6, color: t.goldBright, textTransform: 'uppercase' },
    title: { fontSize: 16, fontWeight: '800', color: t.ivory, lineHeight: 20 },
    state: { fontSize: 12, color: t.ivorySoft },
    go: { alignSelf: 'flex-end', marginTop: 2 },
    goText: { fontSize: 13, fontWeight: '800', color: t.goldBright },
  }),
);
